import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

export const Layout: FC<LayoutProps> = ({ children, header, footer }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main-content'
                className='sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[60] focus:rounded-full focus:bg-foreground focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-background'
            >
                Skip to content
            </a>

            {header}

            <main id='main-content' className='flex-1'>
                {children}
            </main>

            {footer}
        </div>
    )
}
